export default "__VITE_ASSET__BSdWNk1b__"